// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-selectable-list-docs',
    templateUrl: './selectable-list.docs.generated.html',
})
export class UISelectableListDocs { }
